module.exports = __webpack_public_path__ + "img/fancy.18d1726.webp";